import { Grid, MenuItem } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import DarkerDisabledTextField from "../../../commons/formComponents/darkerDisabledTextField";
import FormikActions from "../../../commons/formik/formikActions";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";
import { StyledCommonForms } from "../../../styled/form";
import DropZone from "../dropZone/dropZone";
import FormSectionDivider from "../formSectionDivider";
import { idrValidation, validateRequiredFields } from "../formValidation";
import ProfessionalControl from "../professionalControl/professionalControl";

const Idr = ({
  handleClose,
  files,
  setFiles,
  handleSubmit,
  model,
  formValues,
  selectedDocument,
  disabled,
  idArt,
}) => {
  const [attachmentError, setAttachmentError] = useState(false);
  const [professionalError, setProfessionalError] = useState(false);

  const fields = model.fields;

  return (
    <FormikForm
      artFields={fields}
      initialValues={formValues}
      validationSchema={() => idrValidation()}
      validate={(values) => {
        const errors = validateRequiredFields(values, fields)
        if (model.configuration.requiresAttachment && files.length === 0) {
          errors.attachment = "Adjunto requerido";
          setAttachmentError(true);
        }
        return errors;
      }}
      onSubmit={(values) => {
        if (!professionalError) {
          handleSubmit(values);
        }
      }}>
      {({ values, setFieldValue }) => (
        <StyledCommonForms.FormContainer>

          <StyledCommonForms.FieldContainer sx={{ maxHeight: 'min(calc(100dvh - 124px) ,calc(100vh - 124px))' }}>
            <FormSectionDivider title="Informe / Documentación Respaldatoria" />
            {model.configuration.showTypeFormCombo && (
              <StyledCommonForms.RowContainer>
                <FormikSelect
                  name="nombreTipoFormulario"
                  label={`Tipo de Formulario Especifico ${fields.nombreTipoFormulario.required ? "*" : ""
                    }`}
                  value={formValues.nombreTipoFormulario}
                  variant="outlined"
                  sx={StyledCommonForms.input}
                  disabled={disabled}>
                  {fields.tiposFormulario.options.map((f) => {
                    return (
                      <MenuItem key={f.nombre} value={f.nombre}>
                        {f.formulario} - {f.nombre}
                      </MenuItem>
                    );
                  })}
                </FormikSelect>
              </StyledCommonForms.RowContainer>
            )}
            <Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
              <Grid item xs={12} sm={6}>
                <FormikDateTimePicker
                  name="fechaHora"
                  label={`Fecha Hora ${fields.fechaHora.required ? "*" : ""}`}
                  inputVariant="outlined"
                  sx={StyledCommonForms.input}
                  disabled={true}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormikAutocomplete
                  name="nroFormularioFPA"
                  label={`Pedido de Autorización para asociar ${fields.nroFormularioFPA.required ? "*" : ""
                    }`}
                  variant="outlined"
                  options={fields.nroFormularioFPA.options}
                  sx={StyledCommonForms.input}
                  renderOption={(option) =>
                    `${moment(option.fecha).format("DD/MM/YYYY HH:mm")} ${option.estado ? "-" : ""
                    } ${option.estado || ""} ${option.detalle ? "-" : ""}  ${option.detalle || ""
                    }`
                  }
                  labelOption={(option) =>
                    `${moment(option.fecha).format("DD/MM/YYYY HH:mm")} ${option.estado ? "-" : ""
                    } ${option.estado || ""}`
                  }
                  filterOptions={(option) =>
                    moment(option.fecha).format("DD/MM/YYYY HH:mm") +
                    option.estado +
                    option.detalle
                  }
                  disabled={disabled}
                />
              </Grid>

            </Grid>
            <StyledCommonForms.RowContainer>
              <DarkerDisabledTextField
                label=""
                type="text"
                variant="outlined"
                multline
                value="Recuerde la importancia para la ART de asociar el Pedido de Autorización correspondiente al Informe enviado en esta evolución, si existiera uno."
                multiline
                sx={StyledCommonForms.input}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextFieldSpeech
                id="detalle"
                name="detalle"
                label={`Detalle ${fields.detalle.required ? "*" : ""}`}
                placeholder="Copie aquí el Informe de Estudio o detalle del adjunto"
                type="text"
                variant="outlined"
                multiline
                minRows={3}

                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <FormSectionDivider title="Profesional" />
            <ProfessionalControl
              disabled={disabled}
              fields={fields}
              values={values}
              setFieldValue={setFieldValue}
              profesionalPreCarga={formValues.profesionalApellidoNombre}
              error={professionalError}
              setError={setProfessionalError}
              especialidadesProfesional={fields.especialidadProfesional}
              habilitarEspecialidadInforme={true}
              idArt={idArt}
            />
            {model.configuration.showAttachments && (
              <div>
                <FormSectionDivider title="Adjuntos" />
                <StyledCommonForms.RowContainer>
                  <DropZone
                    files={files}
                    setFiles={setFiles}
                    configuration={model.configuration}
                    error={attachmentError}
                    setError={setAttachmentError}
                    disabled={disabled}
                    selectedDocument={selectedDocument}
                    accept={model.configuration.availableExtensions}
                  />
                </StyledCommonForms.RowContainer>
              </div>
            )}
          </StyledCommonForms.FieldContainer>
          <StyledCommonForms.ActionsContainer>
            <FormikActions handleCancel={handleClose} disabled={disabled} />
          </StyledCommonForms.ActionsContainer>
        </StyledCommonForms.FormContainer>
      )}
    </FormikForm>
  );
};

export default Idr;
